import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { openChat } from "@/lib/chatBus";

/**
 * Legacy-route bridge: /app/chat(/:masterId)?context=&prompt= used to be a
 * full page. The Master Chat now lives in the floating widget, so this
 * component simply opens the widget (with the same params) and redirects
 * to Home. Keeps old bookmarks and deep links working.
 */
export default function ChatRedirect() {
    const { masterId } = useParams();
    const [searchParams] = useSearchParams();
    const nav = useNavigate();

    useEffect(() => {
        openChat({
            masterId: masterId === "master_recruiter_agent" ? "master_recruiter_agent" : (masterId ? "master_sales_agent" : undefined),
            context: searchParams.get("context") || undefined,
            prompt: searchParams.get("prompt") || undefined,
        });
        nav("/app/home", { replace: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
}
